import type { NpsConfig } from '@features/partners/builder/settings/nps/models/nps';
import type { Observable } from 'rxjs';

import { inject } from '@angular/core';
import { NpsService } from '@features/partners/builder/settings/nps/services/nps.service';

export const npsConfigResolver = (): Observable<NpsConfig> => inject(NpsService).npsConfig$;
